export default "__VITE_ASSET__Bye6_ERj__"